/**
 * ForbiddenBanner — exibe mensagem amigável para erros ApiError com status 403.
 *
 * Por que no front: OWASP recomenda que o backend sempre valide e retorne 403;
 * o front apenas melhora a UX apresentando a mensagem em PT-BR com orientação
 * de contato — nunca como única camada de segurança.
 *
 * Uso:
 *   import { ForbiddenBanner } from '@/components/ui';
 *   {error?.isForbidden && <ForbiddenBanner detail={error.detail} />}
 */
import { ShieldCheck } from 'lucide-react';
import { C } from '@/theme/palette';

/**
 * @param {{ detail?: string }} props
 */
export function ForbiddenBanner({ detail }) {
  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        padding: '16px 20px',
        borderRadius: 8,
        backgroundColor: `${C.hot}11`,
        border: `1px solid ${C.hot}44`,
        marginBottom: 24,
      }}
    >
      <ShieldCheck
        size={18}
        aria-hidden="true"
        style={{ color: C.hot, flexShrink: 0, marginTop: 1 }}
      />
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, color: C.hot, marginBottom: 4 }}>
          Acesso negado
        </div>
        <div style={{ fontSize: 13, color: C.neutralDim, lineHeight: 1.5 }}>
          {detail
            ? detail
            : 'Você não tem permissão para realizar esta ação. Solicite acesso ao Administrador do tenant.'}
        </div>
      </div>
    </div>
  );
}
